import { formatDuration } from '../lib/time.js';

import { TrackTile } from './TrackTile.js';

import type { ReactElement } from 'react';

type NowPlayingBlockProps = {
  readonly title: string;
  readonly artist: string;
  readonly colour: string;
  readonly size: number;
  readonly imageUrl: string | null;
  readonly positionSeconds: number;
  readonly durationSeconds: number;
  readonly playing: boolean;
};

export const NowPlayingBlock = ({
  title,
  artist,
  colour,
  size,
  imageUrl,
  positionSeconds,
  durationSeconds,
  playing,
}: NowPlayingBlockProps): ReactElement => {
  const remaining = Math.max(0, durationSeconds - positionSeconds);
  const pct = Math.min(100, (positionSeconds / durationSeconds) * 100);

  return (
    <div className="flex items-start gap-3.5">
      <TrackTile title={title} colour={colour} size={size} imageUrl={imageUrl} />
      <div className="min-w-0 flex-1">
        <p className="font-display text-content truncate text-lg leading-tight">{title}</p>
        <p className="text-muted mt-1 truncate text-xs">{artist}</p>
        {playing ? (
          <div className="mt-3">
            <div className="bg-line h-1 overflow-hidden rounded-full">
              <div
                className="h-full rounded-full transition-[width] duration-1000 ease-linear"
                style={{ width: `${String(pct)}%`, backgroundColor: colour }}
              />
            </div>
            <div className="text-muted mt-1.5 flex justify-between text-[11px] tabular-nums">
              <span>{formatDuration(positionSeconds * 1000)}</span>
              <span>-{formatDuration(remaining * 1000)}</span>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
